export default __webpack_public_path__ + "static/media/typescript-plain.a001f7c8.svg";